import { render, staticRenderFns } from "./OtherPersonsEditPanelDialog.vue?vue&type=template&id=5f249e6b"
import script from "./OtherPersonsEditPanelDialog.vue?vue&type=script&lang=js"
export * from "./OtherPersonsEditPanelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports